/* KOTH v3: lazy video play/pause, add-to-cart -> Dawn cart drawer, sticky ATC */
(function(){
  var io='IntersectionObserver' in window&&new IntersectionObserver(function(es){es.forEach(function(e){
    var v=e.target;
    if(e.isIntersecting){if(!v.src&&v.dataset.src){v.src=v.dataset.src;}v.play&&v.play().catch(function(){});}
    else if(v.src){v.pause();}
  });},{rootMargin:'150px',threshold:.25});
  function initVideos(root){(root||document).querySelectorAll('[data-kv-strip] video[data-src]').forEach(function(v){
    if(v._kv)return;v._kv=1; if(io)io.observe(v); else v.src=v.dataset.src;});}
  document.addEventListener('DOMContentLoaded',function(){initVideos();initSticky();});
  document.addEventListener('shopify:section:load',function(e){initVideos(e.target);});

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-kv-add]'); if(!b)return; e.preventDefault();
    var drawer=document.querySelector('cart-drawer'); b.disabled=true;
    var body={items:[{id:+b.dataset.kvAdd,quantity:1}]};
    if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id;});body.sections_url=location.pathname;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(j){
        if(j.status){alert(j.description||'Could not add to cart');return;}
        if(drawer&&drawer.renderContents){drawer.classList.remove('is-empty');drawer.renderContents(j);}
        else location.href='/cart';
      }).catch(function(){location.href='/cart';})
      .finally(function(){b.disabled=false;});
  });

  function initSticky(){
    var bar=document.querySelector('[data-kv-sticky]'); if(!bar)return;
    var form=document.querySelector('product-form, form[action*="/cart/add"]'); bar.hidden=false;
    bar.style.transform='translateY(110%)'; bar.style.transition='transform .25s';
    if(!form||!io){bar.style.transform='';return;}
    new IntersectionObserver(function(es){bar.style.transform=es[0].isIntersecting?'translateY(110%)':'';}).observe(form);
    var vid=document.querySelector('product-form input[name="id"]');
    if(vid)vid.addEventListener('change',function(){bar.querySelector('[data-kv-add]').dataset.kvAdd=vid.value;});
  }
})();

/* v3.1 background loops: pick src by breakpoint, skip on reduced motion, pause offscreen */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  function arm(v){
    if(reduce.matches||!v.dataset.src||!window.matchMedia(v.dataset.mq).matches){ if(v.src){v.pause();} return; }
    if(!v.src){ v.src=v.dataset.src; }
    var p=v.play(); if(p)p.catch(function(){});
  }
  window.KothBg=function(root){
    var vs=(root||document).querySelectorAll('[data-kv-bg]');
    vs.forEach(function(v){
      if(v.dataset.kvArmed)return; v.dataset.kvArmed='1';
      window.matchMedia(v.dataset.mq).addEventListener('change',function(){arm(v);});
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting)arm(v); else if(v.src)v.pause(); });},{rootMargin:'100px'}).observe(v);
      } else arm(v);
    });
  };
  reduce.addEventListener('change',function(){document.querySelectorAll('[data-kv-bg]').forEach(arm);});
  if(document.readyState!=='loading')window.KothBg(); else document.addEventListener('DOMContentLoaded',function(){window.KothBg();});
})();
